import { render } from "./dropdown-label-qty.vue?vue&type=template&id=d121b0c2"
const script = {}

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__